/**
 * Grupos de permissões (v7 — DESIGN-V7 §1). Contratos em
 * packages/shared/src/permissions.ts + apps/api módulo permissions:
 * - GET  /permission-groups          → PermissionGroup[]
 * - POST /permission-groups          → PermissionGroupBody
 * - GET  /permission-groups/:id      → PermissionGroup
 * - PUT  /permission-groups/:id      → PermissionGroupBody (SUBSTITUI
 *   permissions/userIds/attendantGroupIds pelas listas enviadas)
 * - DELETE /permission-groups/:id
 */
import { queryOptions } from '@tanstack/react-query';
import type { PermissionGroup } from '@erp/shared';
import { api, apiList } from '@/lib/api-client';

export function permissionGroupsListOptions() {
  return queryOptions({
    queryKey: ['erp', 'permission-groups', 'list'] as const,
    queryFn: async ({ signal }) => {
      const res = await apiList<PermissionGroup>('/permission-groups', { signal });
      if (res.error) throw res.error;
      return res.data.items;
    },
  });
}

export function permissionGroupDetailOptions(groupId: number) {
  return queryOptions({
    queryKey: ['erp', 'permission-groups', 'detail', { groupId }] as const,
    queryFn: async ({ signal }) => {
      const res = await api<PermissionGroup>(`/permission-groups/${groupId}`, { signal });
      if (res.error) throw res.error;
      return res.data;
    },
  });
}

// Mensagens de erro: helper partilhado (labels dos grupos de permissão já
// vivem lá) — re-exportado para os consumidores desta feature.
export { errorMessage } from '@/features/desks/desks-queries';
